/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import {DataProvider} from './DataProvider';
import {FetchPolicy, NetworkStatus, useResource} from './useResource';

export type {Sorting} from './useResource';
export {DataProvider, FetchPolicy, NetworkStatus, useResource};
export default DataProvider;
